import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AltMessagingGroupChatsProps } from './messaging.props';
import { getGlobalStyleSheets } from '../../global-styles';

import * as TagNames from './messaging.tagnames';
import { ChatAddContactEvent } from './messaging.events';

@customElement(TagNames.MessagingGroupChats)
export class AtlMessagingGroupChats
   extends LitElement
   implements AltMessagingGroupChatsProps
{
   declare groupChatTitle?: string;
   declare showAddContacts?: boolean;

   static properties = {
      groupChatTitle: { type: String },
      showAddContacts: { type: Boolean },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         .messaging-groups-chats-body {
            overflow: inherit !important;
         }
      `,
   ];

   render() {
      return html`
         <div class="messaging-groups-chats">
            <div class="messaging-groups-chats-header">
               ${this.groupChatTitle
                  ? html`<div class="h5 groups-chats-header-title">
                       ${this.groupChatTitle}
                    </div>`
                  : nothing}
               <div class="groups-chats-header-action-buttons">
                  ${this.showAddContacts
                     ? html` <button
                          type="button"
                          class="btn btn-link"
                          aria-label="Add Contact"
                          @click=${() => {
                             this.dispatchEvent(new ChatAddContactEvent());
                          }}
                       >
                          <i
                             class="fa-solid fa-plus header-add-icon-button"
                             aria-hidden="true"
                          ></i>
                       </button>`
                     : nothing}
               </div>
            </div>
            <div class="messaging-groups-chats-body">
               <slot></slot>
            </div>
         </div>
      `;
   }
}
